import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {NgbDropdownConfig} from '@ng-bootstrap/ng-bootstrap';
import {ItemComponent} from '../item/item.component';
import {Api} from '../../providers/api';
import {Auth} from '../../providers/auth';
import {NgxSpinnerService} from 'ngx-spinner';

@Component({
  selector: 'app-home',
  templateUrl: './noticias.component.html',
  styleUrls: ['./noticias.component.css'],
  providers: [NgbDropdownConfig, ItemComponent, Api] // add NgbDropdownConfig to the component providers
})
export class NoticiasComponent implements OnInit {

  name: string;

  noticias = [];
  noticiasCircuito = [];
  circuito;

  showmodal = false;
  item: any;


  constructor(config: NgbDropdownConfig,
              private route: ActivatedRoute,
              private router: Router, private spinner: NgxSpinnerService,
              private api: Api, private auth: Auth) {
    this.name = '';
    // customize default values of dropdowns used by this component tree
    config.placement = 'left-top';
    config.autoClose = true;
    this.getNoticias();
  }

  ngOnInit() {
  }

  showOptionesRow(screen) {
    console.log(screen);
  }

  getNoticias() {
    this.auth.userCheck(() => {
      this.circuito = this.auth.circuito;
      this.spinner.show();
      this.api.getNoticias(this.circuito.id).subscribe((res: any) => {
        console.log(res);
        if (res && res.data) {
          this.noticias = res.data.noticias;
          this.noticiasCircuito = res.data.noticiasCircuito;
          this.noticiasCircuito.forEach((noticia) => {
            noticia.edit = true;
            this.noticias[noticia.id] = noticia;
          });
        } else {
          this.noticias = [];
        }
        this.spinner.hide();
      }, err => {
        this.auth.checkError(err);
        this.spinner.hide();
      });
    }, (err) => {
      this.auth.logout();
    });
  }

  deleteNoticia(noticia) {
    noticia.idCircuito = this.circuito.id;
    console.log(noticia);
    this.spinner.show();
    this.api.deleteNoticia(noticia).subscribe(
      (res: any) => {
        console.log(res);
        this.getNoticias();
        this.spinner.hide();
      }, err => {
        console.log(err);
        alert('ha ocurrido un error al restablecer la noticia');
        this.spinner.hide();
      });
  }

  editarModal(noticia) {
    this.item = {
      action: 'editar_noticia',
      titulo: 'Editar Noticia',
      success_btn_text: 'Guardar Cambios',
      value: noticia
    };
    this.showmodal = true;
  }

  editar(noticia) {
    console.log(noticia);
    noticia.idCircuito = this.circuito.id;
    console.log(noticia);
    this.spinner.show();
    this.api.editNoticia(noticia).subscribe(
      (res: any) => {
        console.log(res);
        this.getNoticias();
        this.spinner.hide();
      }, err => {
        console.log(err);
        this.spinner.hide();
      });
    this.showmodal = false;
  }

}





// WEBPACK FOOTER //
// ./src/app/admin/noticias/noticias.component.ts